import { render } from "./FileManager.vue?vue&type=template&id=85068e32"
import script from "./FileManager.vue?vue&type=script&lang=js"
export * from "./FileManager.vue?vue&type=script&lang=js"

import "./FileManager.vue?vue&type=style&index=0&id=85068e32&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTree from 'quasar/src/components/tree/QTree.js';import Ripple from 'quasar/src/directives/Ripple.js';
import TouchHold from 'quasar/src/directives/TouchHold.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBadge,QTooltip,QInput,QList,QItem,QItemSection,QIcon,QTree});qInstall(script, 'directives', {Ripple,TouchHold});
